module.exports = __webpack_public_path__ + "static/img/brilix.26da76b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/bg/brilix.jpg
// module id = +jCD
// module chunks = 4